import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { GetSeverity, UpdateSoundSettingFunction } from '../../../services/configurationServices';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { toast } from 'react-toastify';

export default function SoundSetting({getAllfromParent, buttonDisable, setButtonDisable}) {
    // region useState start 

    const [enableLowSeverity, setEnableLowSeverity] = useState(false);
    const [enableModerateSeverity, setEnableModerateSeverity] = useState(false);
    const [enableHighSeverity, setEnableHighSeverity] = useState(false);
    const [enableExtremeSeverity, setEnableExtremeSeverity] = useState(false);
    const [isSoundSettingEdit, setIsSonudSettingEdit] = useState(false);
    // const [data, setData] = useState(false);
    const [soundData, setSoundData] = useState([]);
  
      //region useState  end
      
      useEffect(() => {
        getAll()
      }, [])

const getAll = () =>{
  let UserId = localStorage.getItem('UserID');

  try {
    GetSeverity(UserId).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            let extreme = resp.Data.find((item)=> item.SeverityId == 1);
            setEnableExtremeSeverity(extreme.PlaySound);
            let  high = resp.Data.find((item)=> item.SeverityId == 2);
            setEnableHighSeverity(high.PlaySound);
            let  moderate = resp.Data.find((item)=> item.SeverityId == 3);
            setEnableModerateSeverity(moderate.PlaySound);
            let  low = resp.Data.find((item)=> item.SeverityId == 4);
            setEnableLowSeverity(low.PlaySound);
            setSoundData(resp.Data)
            
          } 
        }
      })
} catch (error) {
    console.error(error)
}
}

const updateSoundPage = () => {
  setButtonDisable(true);
  let updatePromises = []; // Array to store promises
  let updatedCount = 0; 
  let errorOccurred = false;
  try { 
    let extreme = enableExtremeSeverity ? "1" :"0";
    let high = enableHighSeverity ? "1" : "0";
    let moderate = enableModerateSeverity ? "1" : "0";
    let low = enableLowSeverity ? "1" : "0";

    let arr = [extreme, high, moderate, low];
    
    for (let i = 0; i < arr.length; i++) {
      let existingRecord = soundData.find((item) => item.SeverityId == i + 1);
      let obj = {
        UserID: localStorage.getItem('UserID'),
        SeveritySoundConfigID: (existingRecord ? existingRecord.Id.toString() : ""),
        SeverityId: (i + 1).toString(),
        OrganizationMasterID: JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
        PlaySound: arr[i]
      };

      // Add the promise to the array
      updatePromises.push(
        UpdateSoundSettingFunction(obj).then((resp) => {
          if (resp != undefined) {
            if (resp.Status == "success") {
              updatedCount++; 
              setSoundData(resp.Data)
              
            } else {
              if (!errorOccurred) {
                showErrorToast(resp.Message);
                errorOccurred = true; // Set the flag to true so it doesn't show again
              }
              // showErrorToast(resp.Message); 
            }
          }
        })
      );
    }

    
    Promise.all(updatePromises).then(() => {
      if (updatedCount === arr.length) {
        SuccessToast('Sound Settings Updated successfully!');
      }
      setIsSonudSettingEdit(false);
      setButtonDisable(false);
      getAll()
      getAllfromParent(); 
    }).catch((error) => {
      console.error('Error during update:', error);
      setButtonDisable(false);
    });

  } catch (error) {
    console.error(error);
    setButtonDisable(false);
  }
};


      const onCancel = (e) => {
        e.stopPropagation()
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to cancel the changes made?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#027aaa",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Leave!"
        }).then((result) => {
          if (result.isConfirmed) {
            getAll()
            setIsSonudSettingEdit(false)
          }
        })
      }
      const showErrorToast = (msg) => {
        toast.error(msg, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      };

  return (
    <div className="col-lg-12 mt-2">
        <div className="SiteMainContainer">
        <div className="soundContainer" 
        // style={{width: "100%"}}
        >
            <>
            <form>
                <div className="PrepostSettingForm PrePostSettingDiv paddingLR300">
                <div className="inputMainContainer w40dot75rem mt300">
                                    <div className="inputTypeLabelContainer h60">
                                        <label className='formFieldLabels'>Play sound by alert severity</label>
                                        <div className='mt-2 signTypeCheckboxLabels'>
                                            <div className="SiteTextBox minWidth150 mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck1"
                                                        style={{ marginLeft: "2px" }}
                                                        checked={enableLowSeverity}
                                                        disabled={!isSoundSettingEdit}
                                                        // value={data.PlaySound}
                                                        onChange={() => {
                                                          setEnableLowSeverity(!enableLowSeverity)
                                                          
                                                          // setenablePlaySound(!enablePlaySond) 
                                                        }}

                                                        // {...register("isWebLoginAllowed")}
                                                        // defaultChecked={user?.isWebLoginAllowed}
                                                        // disabled={!isUserEdit || webBoxDisabled}
                                                    />
                                                    <label className="" htmlFor="exampleCheck1">
                                                        Low
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox minWidth150 mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck2"
                                                        style={{ marginLeft: "2px" }}
                                                        checked={enableModerateSeverity}
                                                        // value={data.PlaySound}
                                                        disabled={!isSoundSettingEdit}
                                                        onChange={() => {
                                                          setEnableModerateSeverity(!enableModerateSeverity)
                                                          
                                                          // setenablePlaySound(!enablePlaySond)
                                                          
                                                        }}
                                                        // {...register("isMobileLoginAllowed")}
                                                        // defaultChecked={user?.isMobileLoginAllowed}
                                                        // disabled={!isUserEdit || mobileBoxDisabled}
                                                    />
                                                    <label className="" htmlFor="exampleCheck2">
                                                        Moderate
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox minWidth150 mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck3"
                                                        style={{ marginLeft: "2px" }}
                                                        checked={enableHighSeverity}
                                                        
                                                        disabled={!isSoundSettingEdit}
                                                        onChange={() => {
                                                          setEnableHighSeverity(!enableHighSeverity)
                                                         
                                                          // setenablePlaySound(!enablePlaySond)
                                                          
                                                        }}
                                                        // {...register("isMobileLoginAllowed")}
                                                        // defaultChecked={user?.isMobileLoginAllowed}
                                                        // disabled={!isUserEdit || mobileBoxDisabled}
                                                    />
                                                    <label className="" htmlFor="exampleCheck3">
                                                        High
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="SiteTextBox minWidth150 mt-0">
                                                <div
                                                    className="onlyforEnableCheckbox ml-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox_custom"
                                                        id="exampleCheck4"
                                                        style={{ marginLeft: "2px" }}
                                                        checked={enableExtremeSeverity}
                                                       
                                                        disabled={!isSoundSettingEdit}
                                                        onChange={() => {
                                                          setEnableExtremeSeverity(!enableExtremeSeverity)
                                                          // setenablePlaySound(!enablePlaySond)
                                                          
                                                          
                                                        }}
                                                        // {...register("isMobileLoginAllowed")}
                                                        // defaultChecked={user?.isMobileLoginAllowed}
                                                        // disabled={!isUserEdit || mobileBoxDisabled}
                                                    />
                                                    <label className="" htmlFor="exampleCheck4">
                                                        Extreme
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                </div>
            </form>

          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            {
             !isSoundSettingEdit &&
              (
                <button
                  className="DataAccessEdit"
                  style={{ width: "100px" }}
                  onClick={() => {
                    // setIsPrePostEdit(false);
                    setIsSonudSettingEdit(true);
                  }}
                >
                  <span className="ViewUpdate">Edit</span>
                </button>
              )
            }

            {/* {
            //   selectedBrandMaster != null && !isPrePostEdit && alertPrePostId == "" &&
              (
                <button
                  className="DataAccessEdit"
                  style={{ width: "100px" }}
                 //onClick={onSaveAlertPrePost}

                >
                  <span className="ViewUpdate">Save</span>
                </button>
              )
            } */}

            {
             isSoundSettingEdit &&
              (
                <>
                  <button
                    className="DataAccessEdit"
                    style={{ width: "100px" }}
                    onClick={updateSoundPage}
                    disabled={buttonDisable}
                  >
                    <span className="ViewUpdate">Update</span>
                  </button>
                  <button
                    className="DataAccessEdit"
                    style={{ width: "100px" }}
                    onClick={(e) => {
                      onCancel(e);
                      //getAll()
                      //setIsSonudSettingEdit(false);
                  }}
                  >
                    <span className="ViewUpdate">Cancel</span>
                  </button>
                </>
              )
            }
          </div>
            </>
        </div>
      </div>
    </div>
  )
}
